import { JobRecordStatus, type JobRecord } from "@rebuild/shared/models";
import { isJobActive, useJobStatus, type UseJobStatusOptions } from "./useJobStatus";

interface EstimateJobStatus {
  jobs: JobRecord[];
  hasActiveJobs: boolean;
  allCompleted: boolean;
  hasFailedJobs: boolean;
}

export function useEstimateJobStatus(estimateId: string, options: UseJobStatusOptions = {}): EstimateJobStatus {
  const { data } = useJobStatus(estimateId, options);
  const jobs = data ?? [];
  return {
    jobs,
    hasActiveJobs: jobs.some(isJobActive),
    allCompleted: jobs.length > 0 && jobs.every((job) => job.status === JobRecordStatus.completed),
    hasFailedJobs: jobs.some((job) => job.status === JobRecordStatus.failed),
  };
}
